import {SEND_RECLAMO, 
    GET_DATA_USER,
    RECLAMO_ENVIADO,
    DATA_RECLAMO_ENVIADO,
    GET_ARCHIVOS,
    GET_PHONE_NUMBER,
    GET_TEMPORALES,
    ENVIANDO_DATA,
    PRIMERA_LLAMADA,
    EXISTENTE_ERROR
} from '../type';

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action)=> {
    switch (action.type) {
        case SEND_RECLAMO:
            return{
                ...state,
                send: action.payload
            };
        case GET_DATA_USER:
            return{
                ...state,
                data_usuario:action.payload
            };
        case RECLAMO_ENVIADO:
            return{
                ...state,
                enviado: action.payload
            }
        case DATA_RECLAMO_ENVIADO:
            return{
                ...state,
                reclamo_enviado: action.payload
            }
        case GET_ARCHIVOS:
            return{
                ...state,
                archivos: action.payload
            }
        case GET_PHONE_NUMBER:
            return{
                ...state,
                phone_number: action.payload
            }
        case GET_TEMPORALES:
            return{
                ...state,
                reclamos_temporales: action.payload
            }
        case ENVIANDO_DATA:
            return{
                ...state,
                enviando_data: action.payload
            }
        case PRIMERA_LLAMADA:
            return{
                ...state,
                primera_llamada: action.payload
            }
        case EXISTENTE_ERROR:
            return{
                ...state,
                existente_error: action.payload
            }
        default:
            return state;
    }    
}